/* eslint-env jquery */

function getForm() {
  return $("#main_body form");
}

function getFormRows() {
  return getForm().find("li");
}

export default { getForm, getFormRows };
